import apiClient from '../utils/apiClient';

/**
 * Product Service
 * Handles all API calls related to products
 */
const productService = {
  /**
   * Get all products with pagination
   * @param {Number} page - Page number
   * @param {Number} limit - Number of items per page
   * @returns {Promise} - Promise resolving to products data
   */
  getProducts: async (page = 1, limit = 10) => {
    try {
      const response = await apiClient.get(`/products?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  /**
   * Create a new product
   * @param {FormData} formData - Product form data including possible image
   * @returns {Promise} - Promise resolving to created product
   */
  createProduct: async (formData) => {
    try {
      const response = await apiClient.post(`/products`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating product:', error);
      throw error;
    }
  },

  /**
   * Update an existing product
   * @param {String} id - Product ID
   * @param {FormData} formData - Updated product form data
   * @returns {Promise} - Promise resolving to updated product
   */
  updateProduct: async (id, formData) => {
    try {
      const response = await apiClient.put(`/products/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating product:', error);
      throw error;
    }
  },

  /**
   * Get a single product by ID
   * @param {String} id - Product ID
   * @returns {Promise} - Promise resolving to product data
   */
  getProduct: async (id) => {
    try {
      const response = await apiClient.get(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  /**
   * Delete a product
   * @param {String} id - Product ID
   * @returns {Promise} - Promise resolving to deletion result
   */
  deleteProduct: async (id) => {
    try {
      const response = await apiClient.delete(`/products/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting product:', error);
      throw error;
    }
  }
};

export default productService;
